import { render, staticRenderFns } from "./finish.vue?vue&type=template&id=60b16c96&scoped=true&"
import script from "./finish.vue?vue&type=script&lang=js&"
export * from "./finish.vue?vue&type=script&lang=js&"
import style0 from "./finish.vue?vue&type=style&index=0&id=60b16c96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b16c96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60b16c96')) {
      api.createRecord('60b16c96', component.options)
    } else {
      api.reload('60b16c96', component.options)
    }
    module.hot.accept("./finish.vue?vue&type=template&id=60b16c96&scoped=true&", function () {
      api.rerender('60b16c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/pages/_poll/finish.vue"
export default component.exports